Librarian.Modules.CollaborationTopics = new Class({
    Extends: Librarian.Modules.Module,
    Binds: [],

    options: {
        classPrefix: "modules-collaborationtopics-",
        label: null,
        category: null,
        pageName: "collaboration",
        viewAll: false,
        viewAllTitle: false,
        count: 20
    },

    initialize: function (options, wrapperEl) {
        this.setOptions(options);
        this.parent(this.options, wrapperEl);
    },

    load: function () {
        var self = this;

        if (!this.wrapperEl) {
            return;
        }

        this.parent();

        if (!this.containerEl) {
            return;
        }

        Librarian.Utils.getTopics(this.options.count, function (topics) {
            if (self.options.viewAll) {
                // add view all button
                new Element("span", {
                    "class": "viewAll",
                    events: {
                        click: function (event) {
                            Librarian.Modules.Nav.navigateToPage(self.options.pageName);
                        }
                    },
                    text: "View all"
                }).injectInside(self.headerEl);
            }

            if (self.options.viewAllTitle) {
                titleEl = self.headerEl.getElement("." + self.options.classPrefix + "header-text");
                titleEl.addOnClick(function() {
                    window.location.hash = ("page=" + self.options.pageName + "&category=" + self.options.category);
                });
            }

            topics.forEach(function (topic) {
                if (!self.options.category || self.options.category == topic.categoryName) {
                    var linkEl = new Element("div", {
                        "class": "topic-link",
                        events: {
                            click: function (event) {
                                window.location.hash = ("page=" + self.options.pageName + "&topicid=" + topic.topicId);
                            }
                        }
                    }).injectInside(self.containerEl);

                    var date = new Date(topic.dateCreated),
                        dateString = date.getDate() + "-" + (date.getMonth() + 1) + "-" + date.getFullYear();

                    new Element("span", {
                        "class": "topic-link-text",
                        html: topic.subject,
                        title: topic.subject
                    }).injectInside(linkEl);

                    new Element("span", {
                        "class": "topic-link-date",
                        html: dateString,
                        title: dateString
                    }).injectInside(linkEl);

                    new Element("span", {
                        "class": "topic-link-message",
                        html: topic.message,
                        title: topic.message
                    }).injectInside(linkEl);

                    new Element("span", {
                        "class": "topic-link-author",
                        html: topic.createdBy.displayName,
                        title: topic.createdBy.displayName
                    }).injectInside(linkEl);
                }
            });
        });
    }
});